import Select from 'components/common/forms/Select'
import ErrorPanel from 'components/common/panel/ErrorPanel'
import { MDBRow, MDBCol, MDBInput } from 'mdbreact'
import React from 'react'
import { inputErrorClass } from 'utils/formUtils'

const SrAdminForm = ({
  params,
  setParams,
  srDocumentTypes,
  selected,
  setSelected,
  errors,
}) => {
  //// HOOKS.

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <MDBRow>
      {/* name field */}
      {!(params?.name?.length >= 0) ? (
        ''
      ) : (
        <MDBCol md="12">
          <MDBInput
            autoFocus
            value={params.name}
            getValue={(value) => {
              setParams({ ...params, name: value })
              if (selected) setSelected({ ...selected, name: value })
            }}
            id="name-input"
            label="Name"
            type="text"
            outline
            required
            containerClass="required-label"
            className={`input-select${inputErrorClass(errors, !params.name)}`}
          />
        </MDBCol>
      )}

      {/* value field */}
      {!(params?.value?.length >= 0) ? (
        ''
      ) : (
        <MDBCol md="12">
          <MDBInput
            value={params.value}
            getValue={(value) => {
              setParams({ ...params, value: value })
              if (selected) setSelected({ ...selected, value: value })
            }}
            id="name-input"
            label="Value"
            type="text"
            outline
            required
            containerClass="required-label"
            className={`input-select${inputErrorClass(errors, !params.value)}`}
          />
        </MDBCol>
      )}

      {/* type select */}
      {!srDocumentTypes ? (
        ''
      ) : (
        <MDBCol md="12">
          <Select
            id="select__srDocument-types"
            options={srDocumentTypes}
            getTextContent={(v) => {
              if (v !== 'Choose A Type') {
                const typeSelection = srDocumentTypes.filter(
                  (type) => type.value === v
                )
                setParams({
                  ...params,
                  sr_document_type_id: typeSelection[0].id,
                })

                const newType = srDocumentTypes.filter(
                  (item) => item.value === v
                )
                if (selected)
                  setSelected({
                    ...selected,
                    sr_document_type: {
                      id: newType[0].id,
                      name: newType[0].value,
                    },
                  })
              }
            }}
            label="Type"
            defaultOption="Choose A Type"
            required
            search
            errors={errors}
          />
        </MDBCol>
      )}
      <ErrorPanel results={errors} />
    </MDBRow>
  )
}

export default SrAdminForm
